module.exports = __webpack_public_path__ + "static/1-1573edf7736d1fe2cc73ee528ee42db4.png";